/** Created by azhou on 2019/3/25.*/
<template>
    <div>
      <public-title>
        导游人员列表
      </public-title>
      <!-- 导游搜索条件与其他的割裂 -->
      <div class="load-area">
        <transition name="el-zoom-in-top" v-if="activeName === 'storeListSearch'">
          <search-con  class="mt-2" @getSearchCon="getSearchCon" :total="AdminDataLists.total"/>
        </transition>
        <p v-if="AdminDataLists.total<=0 && activeName != 'roomTypeTrends'" class="mt-3">当前没有数据</p>
        <div v-else>
          <ul v-if="activeName != 'roomTypeTrends'" class="list-head mt-3">
                <li  :class="item.class" v-for="item in titleArr" :key="item.name">
                {{item.name}}
                </li>
            </ul>
              <!-- 导游 -->
            <ul class="list-item"  v-for="(item,index) in AdminDataLists.lists" :key="index">
                <li class="w-50 list-item-col text-muted" >{{item.title}}</li>
                <li class="w-50 list-item-col">{{item.mob}}</li>
                <li class="w-50 list-item-col">{{item.id_card||'无'}}</li>
                <li class="w-50 list-item-col">{{item.sex | formatVar('sex')}}</li>
                <li class="w-50 list-item-col text-muted breakword">{{item.level}}</li>
                <li class="w-50 list-item-col" :class="[item.verify==1?'text-success':'text-danger']">
                    {{item.verify | formatVar('verifyType')}}
                </li>
                <li class="w-50 list-item-col" :class="[item.display==1?'text-success':'text-danger']">
                    {{item.display == 1 ?'已显示':'未显示'}}
                </li> 
                <li class="w-50 list-item-col-end">
                    <span  class="text-link" @click="goStoreDetail(item.id)">编辑</span>
                    <!-- <span v-else class="text-link" @click="$router.push({name:'GuideMsg',query:{id:item.id,store:$route.query.store}})">查看</span> -->
                </li>
            </ul>
            <el-pagination background layout="prev, pager, next" 
                class="mt-4"
                v-if="activeName !== 'roomTypeTrends'"
                :page-size="20"
                :total="AdminDataLists.total" :current-page="Number(queryCon.page)"
                @current-change="$GFUN.pageChange"/>
        </div>
      </div>
    </div>
</template>

<script>
  import { mapGetters, mapActions,mapState,mapMutations } from 'vuex'
    import SearchCon from "./SearchCon.vue";
  export default {
    name: 'StoreManageIndex',
    components: {SearchCon},
    computed: {
      ...mapGetters(['storeInfo']),
      queryCon() { return this.$route.query },
      titleArr() {
        return [{name:'导游名称',class:'w-50'},{name:'手机号',class:'w-50'},{name:'身份证号',class:'w-50'},{name:'性别',class:'w-50'},{name:'导游级别',class:'w-50'},{name:'认证状态',class:'w-50'},{name:'显示状态',class:'w-50'},{name:'操作',class:'w-50'}];
      }
    },
    watch:{
      'queryCon.storeType'() {
        this.activeName = 'storeListSearch'
        this.showSearch = false;  //收起搜索面板
        this.searchCon = {};      //清空搜索条件
        this.getDataLists();
      },
      'queryCon.page'() {
        this.getDataLists();
      }
    },
    created () {
      if (this.queryCon.back) this.activeName = 'roomTypeTrends'
    },
    mounted() { this.getDataLists();},
    data() {
      return {
        activeName:'storeListSearch',
        showSearch:false,
        showConfirmPanel:false,
        searchCon:{},
        unread: 0,
        Sorts:0,
        AdminDataLists:{
          lists:[],
          total:0,  
        },
        loading: false
      }
    },
    methods:{
      ...mapMutations(['UPDATECURRENTSTORE','UPDATESTOREBASIC']),
      ...mapActions(['POST_Admin_AddStore','POST_Admin_StoreList']),
      /*排序*/
      Sort(){
        if(this.Sorts!=2){
            this.Sorts++
        }else{
            this.Sorts=0
        }
        this.getDataLists()
      },
      getDataLists() {
        this.loading = true;
        let data = {
          ...this.searchCon,
          order_score:this.Sorts,
          num:20,
          page:this.queryCon.page || 1,
          storeType:4
        }
        this.POST_Admin_StoreList({data,successFun:(res)=>{
          this.AdminDataLists=res;
          this.loading = false;
        }});
      },
      //查看门店详情页
      goStoreDetail(id) {
        let routeUrl = this.$router.resolve({name:'StoreDetail',query:{type:4,id,none:1}});
        window.open(routeUrl.href, '_blank');
      },
      //编辑门店信息
      editStore(id) {
        if (!this.$GFUN.powerIsInArray([427,362,52,98])) { this._alert('您没有相关权限！',null,'error'); return; }
        let routeUrl = this.$router.resolve({name:'StoreBasicInfo',query:{type:this.queryCon.storeType,store:id,none:1}});
        window.open(routeUrl.href, '_blank');
      },
      //查看支付明细和积分明细
      goDetailList(type,id,storeName) {
        let routeUrl = this.$router.resolve({
          name:'DetailList',
          query:{
            type,
            storeType:4,
            storeId:id,
            storeName
          }
        });
        window.open(routeUrl.href, '_blank');
      },
      //搜索门店条件
      getSearchCon(info) {
        this.searchCon = info;
        this.getDataLists();
      },
    }
  }
</script>

<style lang="scss" scoped>
  .unread-msg {
      top: 0;
      left: 75px;
  }
  .pasi{
      width: 13px;
      cursor: pointer;
  }
  .w-1{
    width: 40px;
  }
  .load-area{
    min-height: 600px;
  }
</style>
